<template>
	<div
		class="bg-gray-100 px-6 py-4 text-gray-500 sm:flex sm:items-end sm:justify-between sm:space-x-4"
	>
		<slot></slot>

		<!-- progress bar -->
		<div
			aria-label="Progress"
			class="flex items-baseline sm:block mt-4 sm:mt-0"
		>
			<ol
				role="list"
				class="flex items-center justify-end space-x-5 sm:mb-2 mr-5 sm:mr-0"
			>
				<li v-for="(item, index) in steps">
					<span
						v-if="index + 1 < step"
						v-on:click="$emit('change', index + 1)"
						class="block w-2.5 h-2.5 bg-green-500 rounded-full hover:bg-green-600 cursor-pointer"
					>
						<span class="sr-only">{{ item.name }}</span>
					</span>
					<span
						v-else-if="index + 1 === step"
						class="relative flex items-center justify-center"
						aria-current="step"
					>
						<span class="absolute w-5 h-5 p-px flex" aria-hidden="true">
							<span class="w-full h-full rounded-full bg-green-200" />
						</span>
						<span
							class="relative block w-2.5 h-2.5 bg-green-500 rounded-full"
							aria-hidden="true"
						/>
						<span class="sr-only">{{ item.name }}</span>
					</span>
					<!-- v-on:click="tryGotoStep(index+1)" -->
					<span v-else class="block w-2.5 h-2.5 bg-gray-200 rounded-full">
						<span class="sr-only">{{ item.name }}</span>
					</span>
				</li>
			</ol>
			<p class="font-medium whitespace-nowrap" v-if="step <= steps.length">
				<span v-if="locale == 'de'"
					>Schritt {{ step }} von {{ steps.length }}
				</span>
				<span v-if="locale == 'en'"
					>Step {{ step }} of {{ steps.length }}
				</span>
			</p>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		step: {
			required: false,
		},
		steps: {
			type: Array,
			required: true,
		},
	},
};
</script>
